import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { ApiService } from '../../../services/api_service';

interface StandorteGruppenProps extends React.ClassAttributes<any> {

}

interface StandorteGruppenState {

}

export class StandorteGruppen extends React.Component<StandorteGruppenProps, StandorteGruppenState> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_STANDORT_GRUPPE}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    addLabel={ApiService.bereichKey === 'kommunalverwaltung' ? 'Kategorie-Gruppe erfassen' :  'Standort-Gruppe erfassen'}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' || action === 'delDone') {
                            this.triggerService.fire('reload', IDs.ENT_STANDORT_GRUPPE);
                            this.triggerService.fire('reload', IDs.ENT_STANDORT);
                        }
                    }}
                />
            </div>
        );
    }

}
